import { graphql } from '@/graphql-setup'

export const CREATE_SALARY_ITEM_GENERATION_RULE_MUTATION = graphql(`
  mutation CreateSalaryItemGenerationRule(
    $input: SalaryItemGenerationRuleInput!
  ) {
    createSalaryItemGenerationRule(input: $input) {
      generationRule {
        id
      }
    }
  }
`)

export const PATCH_SALARY_ITEM_GENERATION_RULE_MUTATION = graphql(`
  mutation PatchSalaryItemGenerationRule(
    $id: ID!
    $input: SalaryItemGenerationRuleInput!
  ) {
    patchSalaryItemGenerationRule(id: $id, input: $input) {
      generationRule {
        id
      }
    }
  }
`)

export const DELETE_SALARY_ITEM_GENERATION_RULE_MUTATION = graphql(`
  mutation DeleteSalaryItemGenerationRule($id: ID!) {
    deleteSalaryItemGenerationRule(id: $id) {
      found
    }
  }
`)

export const CREATE_SALARY_ITEM_GENERATION_MODIFIER_MUTATION = graphql(`
  mutation CreateSalaryItemGenerationModifier(
    $input: SalaryItemGenerationModifierInput!
  ) {
    createSalaryItemGenerationModifier(input: $input) {
      generationModifier {
        id
      }
    }
  }
`)

export const PATCH_SALARY_ITEM_GENERATION_MODIFIER_MUTATION = graphql(`
  mutation PatchSalaryItemGenerationModifier(
    $id: ID!
    $input: SalaryItemGenerationModifierInput!
  ) {
    patchSalaryItemGenerationModifier(id: $id, input: $input) {
      generationModifier {
        id
      }
    }
  }
`)

export const DELETE_SALARY_ITEM_GENERATION_MODIFIER_MUTATION = graphql(`
  mutation DeleteSalaryItemGenerationModifier($id: ID!) {
    deleteSalaryItemGenerationModifier(id: $id) {
      found
    }
  }
`)

export const PATCH_SALARY_WORK_TIME_LEGACY_DIET_MUTATION = graphql(`
  mutation PatchSalaryWorkTimeLegacyDiet(
    $id: ID!
    $input: PatchSalaryWorkTimeInput!
  ) {
    patchSalaryWorkTime(id: $id, input: $input) {
      salaryWorkTime {
        id
        useAutomaticDietGeneration
        useAutomaticSalaryDayGeneration
        useAdvancedCalculation
        useSixHourRuleForCalculation
      }
    }
  }
`)
